var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailfooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 16,
    viewBox: "0 0 21 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.38931 15.5556C1.87745 15.5556 1.45042 15.3844 1.10819 15.0422C0.765972 14.7 0.594491 14.2726 0.59375 13.76V1.79556C0.59375 1.2837 0.765232 0.856666 1.10819 0.514444C1.45116 0.172222 1.87782 0.000740741 2.38819 0H18.7993C19.3104 0 19.7371 0.171481 20.0793 0.514444C20.4215 0.857407 20.593 1.28444 20.5938 1.79556V13.7611C20.5938 14.2722 20.4223 14.6993 20.0793 15.0422C19.7363 15.3852 19.3097 15.5563 18.7993 15.5556H2.38931ZM10.5938 7.90667L1.70486 2.09444V13.7611C1.70486 13.9604 1.76894 14.1241 1.89708 14.2522C2.02523 14.3804 2.18931 14.4444 2.38931 14.4444H18.7993C18.9986 14.4444 19.1623 14.3804 19.2904 14.2522C19.4186 14.1241 19.4826 13.96 19.4826 13.76V2.09333L10.5938 7.90667ZM10.5938 6.66667L19.1404 1.11111H2.04708L10.5938 6.66667ZM1.70486 2.09444V1.11111V13.7611C1.70486 13.9604 1.76894 14.1241 1.89708 14.2522C2.02523 14.3804 2.18931 14.4444 2.38931 14.4444H1.70486V2.09444Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailfooter);
export default __webpack_public_path__ + "static/media/mailfooter.8b1154981287def7995429d76f7195c9.svg";
export { ForwardRef as ReactComponent };